import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Modal, Button, Divider, Form, Select, message, Input } from 'antd';
import cloneDeep from 'lodash/cloneDeep';
import lodashGet from 'lodash/get';
import { apis, apiHolder as api, util, FLOLDER, } from 'api';
import ErrorBoundary from '@web-common/hooks/ErrorBoundary';
import classnames from 'classnames';
import moment from 'moment';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { useActions, useAppSelector, MailClassifyActions } from '@web-common/state/createStore';
import ArrowLeftIcon from '@web-common/components/UI/Icons/svgs/disk/ArrowLeft';
import { safeDecodeURIComponent } from '@web-common/utils/utils';
import { ReactComponent as DeleteIcon } from '@/images/icons/modal_close_temp.svg';
import TriangleDownIcon from '@web-common/components/UI/Icons/svgs/TriangleDown';
import styles from './classify-content.module.scss';
import { CancelPopover } from './cancel-popover';
import { EnableAction } from './enableAction';
import { ConditionAction } from './conditionAction';
import { MailAction, mailActionEnum } from './mailAction';
import { ApplyAction } from './applyAction';
import ClassifyList from './ClassifyList/ClassifyList';
import { getIn18Text } from 'api';
import FolderSelectModal from './FolderSelectModal/FolderSelectModal';
import { getDefaultOperatorByField, MAIL_CLASSIFY_BODY_FIELD, normalizeConditionOperatorByField } from './operator_utils';
const MailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const defaultRule = {
    disabled: false,
    condictions: [],
    actions: [],
};
const RULE_NAME_MAX_LENGTH = 40;
const RULE_NAME_ILLEGAL_REG = /[,%'\\"?;<>&*|]/;
const { Option } = Select;
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const systemApi = api.api.getSystemApi();
export const forbidExecActions = [mailActionEnum.forward, mailActionEnum.notice, mailActionEnum.reject];
export const ClassifyContentModal = () => {
    var _a;
    const [form] = Form.useForm();
    const { showMailClassifyModal, mailFolderId, mailSender, mailTitle, mailTag, mailNotice, modalAccount } = useAppSelector(state => state.mailClassifyReducer);
    const _account = useMemo(() => {
        const userData = systemApi.getCurrentUser(modalAccount);
        if (userData === null || userData === void 0 ? void 0 : userData.agentEmail) {
            return userData === null || userData === void 0 ? void 0 : userData.agentEmail;
        }
        return modalAccount;
    }, [modalAccount]);
    const [optionsList, setOptionsList] = useState([]);
    const [modalType, setModalType] = useState('list');
    const { changeShowClassifyModal, setMailFolderId, setMailTitle, setMailSender, setMailTag } = useActions(MailClassifyActions);
    const [loading, setLoading] = useState(false);
    const [closeAfterEdit, setCloseAfterEdit] = useState(false);
    const [showCancelPopover, setShowCancelPopover] = useState(false);
    const [isFirst, setIsFirst] = useState(true);
    const [execFolders, setExecFolders] = useState(undefined);
    const [isEntrance, setIsEntrance] = useState(false);
    const { setShowFolderSelectModal, setSelectedFolders, setFolderExecFun, setRecent100, setIsScopeSent: setReduxIsScopeSent } = useActions(MailClassifyActions);
    useEffect(() => {
        setIsFirst(showMailClassifyModal);
    }, [showMailClassifyModal]);
    const [editData, setEditData] = useState(defaultRule);
    const [conditionData, setConditionData] = useState([]);
    const [accountData, setAccountData] = useState([]);
    const [enableReject, setEnableReject] = useState(false);
    const [isBodyCondition, setIsBodyCondition] = useState(false);
    const [isScopeSent, setIsScopeSent] = useState(false);
    const [isEditRuleMode, setIsEditRuleMode] = useState(false);
    const [operatorValue, setOperatorValue] = useState('and');
    const [selectedAction, setSelectedAction] = useState([mailActionEnum.move]);
    const [tempVisible, setTempVisible] = useState(true);
    const [mailBoxs, setmailBoxs] = useState([]);
    const [ruleList, setRuleList] = useState([]);
    const titleName = useMemo(() => {
        var _a, _b;
        const folderName = (_b = (_a = mailBoxs.find(item => item.entry.mailBoxId === mailFolderId)) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.mailBoxName;
        const setVal = folderName || mailTag || '';
        return setVal;
    }, [mailBoxs, mailFolderId, mailTag]);
    const closeModal = (values) => {
        var _a;
        if (values) {
            const logParams = {};
            if (mailFolderId || mailSender || mailTitle || mailTag) {
                if (mailFolderId) {
                    logParams.page_sorce = 'folder';
                }
                else if (mailTag) {
                    logParams.page_sorce = 'tags';
                }
                else {
                    logParams.page_sorce = 'singleMail';
                }
            }
            else {
                logParams.page_sorce = 'setting';
            }
            logParams.effect_mode = values.enable;
            logParams.rules_mode = values.operator;
            logParams.rules_type = Array.from(new Set(values.condictions.map((item) => item.field))).join(',');
            if (values.action_type === 'reject') {
                logParams.action_type = values.action_type;
            }
            else {
                const { action_type_flags, action_type_move, action_type_read, action_type_reply, action_type_tags, action_type_top } = values;
                const actions = [];
                if (action_type_flags) {
                    actions.push('red_flag');
                }
                if (action_type_top) {
                    actions.push('top');
                }
                if (action_type_read) {
                    actions.push('read');
                }
                if (action_type_tags) {
                    actions.push('tags');
                }
                if (action_type_move) {
                    actions.push('move');
                }
                if (action_type_reply) {
                    actions.push('reply');
                }
                logParams.action_type = actions.join(',');
            }
            logParams.past_email_effect_mode = ((_a = values === null || values === void 0 ? void 0 : values.enable) === null || _a === void 0 ? void 0 : _a.includes('effectHistoryMail')) ? 1 : 0;
            logParams._account = _account;
            trackApi.track('pcMail_click_savebutton_mailClassificationNewPage', logParams);
        }
        if (mailFolderId || mailFolderId === 0 || mailTag) {
            setMailFolderId('');
            setMailTag('');
        }
        setModalType('list');
        if (closeAfterEdit) {
            onClose();
        }
    };
    const beforeCloseModal = () => {
        if (!showCancelPopover) {
            closeModal();
        }
    };
    const fillSubmitConditionData = (values) => {
        var _a;
        let conditions = [];
        const defaultOperandList = optionsList.length > 0 ? optionsList : [(_a = systemApi.getCurrentUser(_account)) === null || _a === void 0 ? void 0 : _a.id];
        conditions = values.condictions.map((item) => {
            const normalizedOperator = normalizeConditionOperatorByField(item.field, item.operator) || getDefaultOperatorByField(item.field);
            const operandList = Array.isArray(item.operand) ? item.operand : item.operand ? [item.operand] : [];
            return Object.assign(Object.assign({}, item), { operator: normalizedOperator, flagOperatorOr: values.operator === 'or', operand: operandList.map(itm => (typeof itm === 'string' ? itm.trim() : itm.email)), ignoreCase: !['accounts'].includes(item.field) });
        });
        conditions.push({
            field: 'accounts',
            ignoreCase: true,
            operator: '',
            operand: (values === null || values === void 0 ? void 0 : values.accounts) ? [...values.accounts] : defaultOperandList,
        });
        if (values.scope === 'savesent') {
            conditions.push({
                field: 'scope',
                ignoreCase: false,
                operator: 'contains',
                operand: ['savesent'],
            });
        }
        return conditions;
    };
    const fillSubmitActionData = (values) => {
        const { action_type, action_type_flags, action_type_move, action_type_read, action_type_reply, action_reply, action_choose_folder, action_type_tags, action_type_top, action_tags, action_forward, } = values;
        const actions = [];
        if (action_type === 'normal') {
            if (action_type_flags || action_type_top || action_type_read) {
                const flagsVal = {};
                if (action_type_flags) {
                    flagsVal.label0 = 1;
                }
                if (action_type_top) {
                    flagsVal.top = !!action_type_top;
                }
                if (action_type_read) {
                    flagsVal.read = !!action_type_read;
                }
                actions.push({
                    disabled: false,
                    type: 'flags',
                    value: flagsVal,
                });
            }
            if (action_type_tags) {
                actions.push({
                    type: 'tags',
                    value: action_tags,
                });
            }
            if (action_type_move) {
                actions.push({
                    disabled: false,
                    type: 'move',
                    target: action_choose_folder,
                });
            }
            if (action_type_reply) {
                actions.push({
                    type: 'reply',
                    content: action_reply.trim(),
                });
            }
        }
        else if (action_type === 'forward') {
            const forwardTarget = action_forward
                ? action_forward
                    .map((t) => t === null || t === void 0 ? void 0 : t.email)
                    .filter(Boolean)
                    .join(',')
                : '';
            actions.push({ type: 'forward', target: forwardTarget, keepLocal: true });
        }
        else if (action_type === 'notice') {
            actions.push({ type: 'notice', noticeType: '1' });
        }
        else {
            actions.push({ type: 'reject', content: 'Reject' });
        }
        if (values.enable.includes('effectHistoryMail')) {
            actions.push({ disabled: false, type: 'history' });
        }
        return actions;
    };
    const forwardValidation = async (values) => {
        if (!values.action_forward || !values.action_forward[0].email || !values.action_forward_validation) {
            return true;
        }
        const res = await accountApi.doCheckVerificationCode(values.action_forward_validation, _account);
        if (!res.success) {
            form.setFields([
                {
                    name: 'action_forward_validation',
                    errors: [getIn18Text('YANZHENGMACUOWU')],
                },
            ]);
        }
        return res.success;
    };
    const selectExecFolder = () => {
        setReduxIsScopeSent(isScopeSent);
        setSelectedFolders(execFolders);
        setFolderExecFun((checkedKeys) => {
            setExecFolders([...checkedKeys]);
            !showCancelPopover && setShowCancelPopover(true);
        });
        setShowFolderSelectModal(true);
    };
    const handleEffectHistoryMail = (id, values) => {
        MailConfApi.effectHistoryMail({ id, ruleIds: undefined, fids: execFolders, _account }).then(res => {
            if (res === null || res === void 0 ? void 0 : res.success) {
                closeModal(values);
                SiriusMessage.success({ content: getIn18Text('GUIZEBAOCUNCHENG11') });
            }
            else {
                SiriusMessage.error({ content: `规则保存成功！${res.title}` });
            }
            setLoading(false);
        });
    };
    const saveEditData = async (values) => {
        var _a, _b;
        if (loading || !showCancelPopover) {
            return;
        }
        if (values.action_type === 'notice') {
            const res = await accountApi.doGetAccountBindAndForwardInfo(_account);
            if (!((_a = res === null || res === void 0 ? void 0 : res.bindInfo) === null || _a === void 0 ? void 0 : _a.mobile)) {
                message.error(getIn18Text('ZHONGYAOYOUJIANTIXINGXU'));
                return;
            }
        }
        setLoading(true);
        const forwardValidationSuccess = await forwardValidation(values);
        if (!forwardValidationSuccess) {
            setLoading(false);
            return;
        }
        const reqData = {
            name: editData.name || `sirius ${moment().format('YYYY-MM-DD HH:mm:ss')}`,
            userRuleName: (_b = values.ruleName) === null || _b === void 0 ? void 0 : _b.trim(),
            continue: editData.continue || true,
            disabled: !values.enable.includes('effectMail'),
        };
        editData.id && (reqData.id = editData.id);
        editData._id && (reqData._id = editData._id);
        reqData.condictions = fillSubmitConditionData(values);
        reqData.actions = fillSubmitActionData(values);
        const interfaceName = editData.id ? 'editMailClassifyRule' : 'addMailClassifyRule';
        MailConfApi[interfaceName]([reqData], _account)
            .then(response => {
            var _a;
            if (response === null || response === void 0 ? void 0 : response.success) {
                const id = (editData === null || editData === void 0 ? void 0 : editData.id) || lodashGet(response, 'data.0', '');
                if (id && ((_a = values === null || values === void 0 ? void 0 : values.enable) === null || _a === void 0 ? void 0 : _a.includes('effectHistoryMail')) && !enableReject && (execFolders === null || execFolders === void 0 ? void 0 : execFolders.length)) {
                    handleEffectHistoryMail(id, values);
                }
                else {
                    closeModal(values);
                    setLoading(false);
                    SiriusMessage.success({ content: response === null || response === void 0 ? void 0 : response.title });
                }
            }
            else {
                setLoading(false);
                SiriusMessage.error({ content: response === null || response === void 0 ? void 0 : response.title });
            }
        })
            .catch(err => {
            console.error('[saveMailClassifyRule]', err);
            setLoading(false);
            SiriusMessage.error({ content: getIn18Text('GUIZEBAOCUNSHIBAI') });
        });
    };
    const genDefaultRuleName = () => {
        const prefix = getIn18Text('我的规则');
        const occupied = new Set(ruleList.map(item => item.userRuleName).filter(Boolean));
        let n = 1;
        while (occupied.has(prefix + n)) {
            n++;
        }
        return prefix + n;
    };
    const createRule = () => {
        var _a, _b;
        const rule = cloneDeep(defaultRule);
        setIsScopeSent(false);
        setReduxIsScopeSent(false);
        setIsEditRuleMode(false);
        form.setFieldsValue({ scope: 'receive' });
        if (mailFolderId) {
            (_a = rule.actions) === null || _a === void 0 ? void 0 : _a.push({
                disabled: false,
                type: 'move',
                target: mailFolderId,
            });
        }
        if (mailTag) {
            (_b = rule.actions) === null || _b === void 0 ? void 0 : _b.push({
                type: 'tags',
                value: [mailTag],
            });
        }
        editRule(rule);
    };
    const deriveIsScopeSent = (conds) => {
        return conds.some(item => item.field === 'scope' && Array.isArray(item.operand) && item.operand.includes('savesent'));
    };
    const editRule = (initRule = defaultRule, _needClose = false) => {
        var _a, _b, _c, _d, _e, _f, _g;
        setEditData(initRule);
        const condition = ((_a = initRule === null || initRule === void 0 ? void 0 : initRule.condictions) === null || _a === void 0 ? void 0 : _a.filter(item => item.field !== 'accounts' && item.field !== 'scope')) || [];
        const operand = ((_c = (_b = initRule.condictions) === null || _b === void 0 ? void 0 : _b.find(item => (item === null || item === void 0 ? void 0 : item.field) === 'accounts')) === null || _c === void 0 ? void 0 : _c.operand) || [];
        setAccountData(operand);
        setConditionData(condition);
        setIsBodyCondition(condition.some(item => (item === null || item === void 0 ? void 0 : item.field) === MAIL_CLASSIFY_BODY_FIELD));
        const nextIsScopeSent = deriveIsScopeSent((initRule === null || initRule === void 0 ? void 0 : initRule.condictions) || []);
        setIsScopeSent(nextIsScopeSent);
        setReduxIsScopeSent(nextIsScopeSent);
        setIsEditRuleMode(!!initRule.id);
        setOperatorValue(((_d = initRule.condictions) === null || _d === void 0 ? void 0 : _d.some(item => item === null || item === void 0 ? void 0 : item.flagOperatorOr)) ? 'or' : 'and');
        const scopeCond = (_e = initRule === null || initRule === void 0 ? void 0 : initRule.condictions) === null || _e === void 0 ? void 0 : _e.find(item => item.field === 'scope');
        const saved = ((_f = scopeCond === null || scopeCond === void 0 ? void 0 : scopeCond.operand) === null || _f === void 0 ? void 0 : _f.includes('savesent')) ? 'savesent' : 'receive';
        form.setFieldsValue({ scope: saved });
        form.setFieldsValue({ ruleName: initRule.userRuleName || (initRule.id ? '' : genDefaultRuleName()) });
        setCloseAfterEdit(_needClose && !mailFolderId && !mailTag);
        const existReject = (_g = initRule === null || initRule === void 0 ? void 0 : initRule.actions) === null || _g === void 0 ? void 0 : _g.some(item => item.type === 'reject');
        setEnableReject(!!existReject);
        if ((mailFolderId || mailTag) && _needClose) {
            return;
        }
        setModalType('edit');
    };
    useEffect(() => {
        const title = mailTitle;
        const senderEmail = mailSender;
        const fid = mailFolderId;
        if (!title && !senderEmail && !fid && !mailTag && mailNotice === 1) {
            return;
        }
        const initRule = {};
        if (senderEmail) {
            initRule.condictions = initRule.condictions || [];
            initRule.condictions.push({
                field: 'from',
                flagOperatorOr: false,
                operator: 'contains',
                operand: [senderEmail],
            });
        }
        if (title) {
            initRule.condictions = initRule.condictions || [];
            initRule.condictions.push({
                field: 'subject',
                flagOperatorOr: false,
                operator: 'contains',
                operand: [safeDecodeURIComponent(title)],
            });
            setIsEntrance(true);
        }
        if (fid) {
            initRule.actions = initRule.actions || [];
            initRule.actions.push({
                disabled: false,
                type: 'move',
                target: fid,
            });
        }
        if (mailTag) {
            initRule.actions = initRule.actions || [];
            initRule.actions.push({
                type: 'tags',
                value: [mailTag],
            });
        }
        if (mailNotice !== 1) {
            initRule.actions = initRule.actions || [];
            initRule.actions.push({
                type: 'notice',
                value: [],
            });
        }
        editRule(initRule, true);
        changeShowClassifyModal(true);
    }, [mailFolderId, mailSender, mailTitle, mailTag, mailNotice]);
    const getMailBox = async () => {
        var _a;
        const res = await mailApi.doListMailBox(true, undefined, undefined, _account);
        const data = [...res];
        const resFlat = [];
        while (data.length) {
            const cur = data.shift();
            if (!cur)
                continue;
            if ((_a = cur.children) === null || _a === void 0 ? void 0 : _a.length) {
                data.push(...cur.children);
            }
            resFlat.push(cur);
        }
        setmailBoxs(resFlat);
    };
    const getRuleList = async () => {
        try {
            const res = await MailConfApi.getMailClassifyRule(_account);
            setRuleList(Array.isArray(res) ? res : []);
        }
        catch (error) {
            console.error('[getMailClassifyRule]', error);
        }
    };
    useEffect(() => {
        if (!showMailClassifyModal) {
            return;
        }
        getMailBox();
        getRuleList();
        if (modalType === 'list') {
            setShowCancelPopover(false);
        }
    }, [_account, modalType, showMailClassifyModal]);
    useEffect(() => {
        setExecFolders(undefined);
    }, [modalType, editData === null || editData === void 0 ? void 0 : editData.id]);
    const looGetOption = () => {
        let time = 0;
        let si = setInterval(() => {
            var _a;
            if (time > 5)
                clearInterval(si);
            const userData = systemApi.getCurrentUser(_account);
            const { isThirdAccount } = userData || {};
            if (isThirdAccount) {
                setOptionsList([_account]);
                clearInterval(si);
            }
            else {
                const list = ((_a = userData === null || userData === void 0 ? void 0 : userData.prop) === null || _a === void 0 ? void 0 : _a.accountAlias) || [];
                if (list === null || list === void 0 ? void 0 : list.length) {
                    setOptionsList(list);
                    clearInterval(si);
                }
            }
            time++;
        }, 500);
    };
    useEffect(() => {
        setOptionsList([]);
        looGetOption();
    }, [_account]);
    const onSubModalVisible = useCallback(visible => {
        setTempVisible(!visible);
    }, []);
    const getRecent100 = async () => {
        var _a, _b;
        try {
            const commonParams = { count: 100, _account };
            const mailReceiveRes = await mailApi.doListMailBoxEntities(Object.assign(Object.assign({}, commonParams), { id: FLOLDER.DEFAULT }));
            const mailSendRes = await mailApi.doListMailBoxEntities(Object.assign(Object.assign({}, commonParams), { id: FLOLDER.SENT }));
            const mails = [
                ...(((_a = mailReceiveRes) === null || _a === void 0 ? void 0 : _a.data) || []).map((item) => {
                    return Object.assign(Object.assign({}, item), { mailTime: new Date(item.entry.receiveTime || 0).getTime() });
                }),
                ...(((_b = mailSendRes) === null || _b === void 0 ? void 0 : _b.data) || []).map((item) => {
                    return Object.assign(Object.assign({}, item), { mailTime: new Date(item.entry.sendTime || 0).getTime() });
                }),
            ]
                .sort((a, b) => {
                return b.mailTime - a.mailTime;
            })
                .splice(0, 100);
            const dRSenders = [];
            const senderSet = new Set();
            const dRReceivers = [];
            const receiverSet = new Set();
            const dRCcs = [];
            const ccSet = new Set();
            const dRReceiverAndCcs = [];
            const receiverAndCcsSet = new Set();
            const dRContacts = [];
            const contactSet = new Set();
            mails.forEach((item) => {
                try {
                    const sender = item.sender;
                    const receiver = item.receiver;
                    const senderId = sender.contactItem.contactItemVal;
                    if (!senderSet.has(senderId)) {
                        dRSenders.push(sender);
                        senderSet.add(senderId);
                    }
                    if (!receiverAndCcsSet.has(senderId)) {
                        dRReceiverAndCcs.push(sender);
                        receiverAndCcsSet.add(senderId);
                    }
                    if (!contactSet.has(senderId)) {
                        dRContacts.push(sender);
                        contactSet.add(senderId);
                    }
                    (receiver || []).forEach(item => {
                        const { mailMemberType } = item;
                        const curId = item.contactItem.contactItemVal;
                        if (curId) {
                            if (mailMemberType === 'to') {
                                if (!receiverSet.has(curId)) {
                                    dRReceivers.push(item);
                                    receiverSet.add(curId);
                                }
                            }
                            if (mailMemberType === 'cc') {
                                if (!ccSet.has(curId)) {
                                    dRCcs.push(item);
                                    ccSet.add(curId);
                                }
                                if (!receiverAndCcsSet.has(curId)) {
                                    dRReceiverAndCcs.push(item);
                                    receiverAndCcsSet.add(curId);
                                }
                            }
                            if (!contactSet.has(curId)) {
                                dRContacts.push(item);
                                contactSet.add(curId);
                            }
                        }
                    });
                }
                catch (error) { }
            });
            const curRecent = {
                senders: dRReceivers.splice(0, 10),
                receivers: dRSenders.splice(0, 10),
                ccs: dRCcs.splice(0, 10),
                receiverAndCcs: dRReceiverAndCcs.splice(0, 10),
                contacts: dRContacts,
                updateTime: new Date().getTime(),
            };
            console.log('setRecent100', curRecent);
            setRecent100(curRecent);
        }
        catch (error) { }
    };
    const onClose = useCallback(() => {
        setMailFolderId('');
        setMailSender('');
        setMailTitle('');
        setMailTag('');
        setEditData(defaultRule);
        setConditionData([]);
        setAccountData([]);
        setEnableReject(false);
        setIsBodyCondition(false);
        setIsEntrance(false);
        setIsScopeSent(false);
        setReduxIsScopeSent(false);
        setIsEditRuleMode(false);
        setOperatorValue('and');
        changeShowClassifyModal(false);
        setExecFolders(undefined);
        form.setFieldsValue({ ruleName: '' });
    }, []);
    const onActionSelect = useCallback(() => {
        if (!showCancelPopover) {
            setShowCancelPopover(true);
        }
    }, []);
    const ClassifyListMemo = useMemo(() => ClassifyList, [editRule, mailBoxs]);
    const enableList = useMemo(() => {
        var _a;
        const list = [];
        if (!(editData === null || editData === void 0 ? void 0 : editData.disabled)) {
            list.push('effectMail');
        }
        if ((_a = editData === null || editData === void 0 ? void 0 : editData.actions) === null || _a === void 0 ? void 0 : _a.find(item => item.type === 'history')) {
            list.push('effectHistoryMail');
        }
        return list;
    }, [editData === null || editData === void 0 ? void 0 : editData.disabled, editData === null || editData === void 0 ? void 0 : editData.actions]);
    const showHisExec = useMemo(() => {
        const userData = systemApi.getCurrentUser(_account);
        if (!userData)
            return false;
        const includeForbitAction = (selectedAction || []).some((item) => forbidExecActions.includes(item));
        return !includeForbitAction;
    }, [_account, selectedAction]);
    useEffect(() => {
        if (showMailClassifyModal)
            getRecent100();
    }, [showMailClassifyModal]);
    return (React.createElement(Modal, { wrapClassName: classnames(styles.classifyContent, { [styles.hide]: showMailClassifyModal ? !tempVisible : false }), bodyStyle: { padding: 0, height: '100%', overflow: 'hidden' }, visible: showMailClassifyModal, footer: null, destroyOnClose: true, maskClosable: false, closeIcon: React.createElement(DeleteIcon, { className: "dark-invert" }), onCancel: onClose, closable: modalType === 'list' || closeAfterEdit, afterClose: closeModal },
        React.createElement(ErrorBoundary, { name: "classify-content-modal", onReset: () => {
                util.reload();
                return false;
            } },
            loading && React.createElement("div", { className: styles.classifyContentLoading }),
            modalType === 'edit' ? (React.createElement(Form, { className: styles.classifyContentWrap, form: form, onFinish: saveEditData, onValuesChange: (changedValues, allValues) => {
                    if (changedValues.action_type === 'reject') {
                        setEnableReject(true);
                    }
                    else if (changedValues.action_type === 'normal') {
                        setEnableReject(false);
                    }
                    setIsBodyCondition(((allValues === null || allValues === void 0 ? void 0 : allValues.condictions) || []).some(item => (item === null || item === void 0 ? void 0 : item.field) === MAIL_CLASSIFY_BODY_FIELD));
                    !showCancelPopover && setShowCancelPopover(true);
                } },
                React.createElement("div", { className: styles.classifyContentHead },
                    React.createElement(CancelPopover, { disable: closeAfterEdit || !showCancelPopover, onConfirm: () => closeModal(), placement: "bottomLeft" },
                        React.createElement("div", { className: classnames(styles.classifyContentBack, { [styles.classifyContentNoCursor]: closeAfterEdit }), onClick: () => {
                                if (!closeAfterEdit) {
                                    beforeCloseModal();
                                }
                            } },
                            !closeAfterEdit ? React.createElement(ArrowLeftIcon, { className: "dark-invert" }) : '',
                            React.createElement("span", { className: styles.classifyContentTitle },
                                editData.id ? getIn18Text('BIANJI') : getIn18Text('XINJIAN'),
                                getIn18Text('FENLEIGUIZE'))))),
                React.createElement("div", { className: classnames(styles.classifyContentDetail, styles.classifyContentEditDetail) },
                    React.createElement("div", { className: styles.ruleNameSection },
                        React.createElement("span", { className: styles.ruleNameSectionLabel }, getIn18Text('规则名称')),
                        React.createElement(Form.Item, { name: "ruleName", className: styles.ruleNameFormItem, rules: [
                                { required: true, message: getIn18Text('请输入规则名称') },
                                { max: RULE_NAME_MAX_LENGTH, message: getIn18Text('MINGCHENGZUIDUOSHU') },
                                { whitespace: true, message: getIn18Text('规则名称不能为空') },
                                {
                                    validator: (_rule, value) => {
                                        if (!value || !value.trim()) {
                                            return Promise.resolve();
                                        }
                                        if (RULE_NAME_ILLEGAL_REG.test(value)) {
                                            return Promise.reject(new Error(getIn18Text('MINGCHENGBUNENGBAO')));
                                        }
                                        const trimmedValue = value.trim();
                                        if (ruleList.some(item => (item.userRuleName || '').trim() === trimmedValue && item._id !== editData._id)) {
                                            return Promise.reject(new Error(getIn18Text('规则名称已存在，请修改后保存')));
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ] },
                            React.createElement(Input, { maxLength: RULE_NAME_MAX_LENGTH, placeholder: getIn18Text('请输入规则名称') }))),
                    optionsList.length > 1 && (React.createElement(React.Fragment, null,
                        React.createElement(ApplyAction, { form: form, operand: accountData, optionsList: optionsList, _account: _account }),
                        React.createElement(Divider, { className: styles.classifyContentDetailDivider }))),
                    optionsList.length <= 1 && (React.createElement(React.Fragment, null,
                        React.createElement(Divider, { className: styles.classifyContentDetailDivider }))),
                    React.createElement("div", { className: styles.scopeSection },
                        React.createElement("span", { className: styles.scopeSectionLabel }, getIn18Text('ZHIXINGSHIJI')),
                        React.createElement(Form.Item, { name: "scope", initialValue: "receive", className: styles.scopeFormItem },
                            React.createElement(Select, { getPopupContainer: node => node.parentElement, suffixIcon: React.createElement(TriangleDownIcon, null), disabled: isEditRuleMode, onChange: (val) => {
                                    const nextIsScopeSent = val === 'savesent';
                                    setIsScopeSent(nextIsScopeSent);
                                    setReduxIsScopeSent(nextIsScopeSent);
                                    setExecFolders(undefined);
                                }, style: { width: 180 } },
                                React.createElement(Option, { value: "receive" }, getIn18Text('SHOUDAOXINYOUJIANS')),
                                React.createElement(Option, { value: "savesent" }, getIn18Text('FAXINSHI')))),
                        React.createElement("span", { className: styles.scopeSectionLabel }, getIn18Text('MANZHUYIXIA')),
                        React.createElement(Form.Item, { name: "operator", initialValue: ((_a = editData.condictions) === null || _a === void 0 ? void 0 : _a.some(item => item === null || item === void 0 ? void 0 : item.flagOperatorOr)) ? 'or' : 'and', className: styles.scopeFormItem },
                            React.createElement(Select, { getPopupContainer: node => node.parentElement, style: { width: 128 }, suffixIcon: React.createElement(TriangleDownIcon, null), onChange: (val) => setOperatorValue(val) },
                                React.createElement(Option, { value: "and" }, getIn18Text('SUOYOUTIAOJIAN')),
                                React.createElement(Option, { value: "or" }, getIn18Text('RENYITIAOJIAN'))))),
                    React.createElement(ConditionAction, { form: form, operator: operatorValue, rules: conditionData, isEntrance: isEntrance, _account: _account, hideHeader: true }),
                    React.createElement(MailAction, { actions: editData === null || editData === void 0 ? void 0 : editData.actions, selectedAction: selectedAction, setSelectedAction: setSelectedAction, onSubModalVisible: onSubModalVisible, onActionSelect: onActionSelect, form: form, _account: _account, isScopeSent: isScopeSent })),
                React.createElement(Divider, null),
                React.createElement("div", { className: styles.classifyContentEditFoot },
                    React.createElement(EnableAction, { showHisExec: showHisExec, form: form, selectedAction: selectedAction, enable: enableList, isDisable: enableReject, _account: _account, isBodyCondition: isBodyCondition }),
                    showHisExec && !isBodyCondition && (React.createElement("span", { onClick: selectExecFolder, className: styles.classifyContentSelectExecFolder }, getIn18Text('XUANZEZHIXINGWENJJ'))),
                    React.createElement("div", { className: styles.classifyContentBtns },
                        React.createElement(CancelPopover, { disable: !showCancelPopover, onConfirm: () => closeModal(), placement: "bottomLeft" },
                            React.createElement(Button, { onClick: () => beforeCloseModal() }, getIn18Text('QUXIAO'))),
                        React.createElement(Form.Item, null,
                            React.createElement(Button, { disabled: !showCancelPopover, type: "primary", htmlType: "submit", loading: loading }, getIn18Text('BAOCUN'))))))) : (React.createElement("div", { className: styles.classifyContentWrap },
                React.createElement("div", { className: styles.classifyContentHead },
                    React.createElement("p", { className: styles.classifyContentTitle }, titleName ? (React.createElement("span", { className: styles.classifyContentTitleFolder },
                        React.createElement("span", null, titleName),
                        React.createElement("span", null, getIn18Text('DEFENLEIGUIZE')))) : (getIn18Text('FENLEIGUIZE'))),
                    React.createElement("p", { className: styles.classifyContentDesc }, getIn18Text('GUIZEJIANGCONGXIA'))),
                React.createElement("div", { className: styles.classifyContentDetail },
                    React.createElement(ClassifyListMemo, { setListShow: show => {
                            setModalType(show ? 'list' : 'edit');
                            setIsFirst(false);
                            if (!show) {
                                createRule();
                            }
                        }, editRule: editRule, mailBoxs: mailBoxs, isFirst: isFirst, _account: _account, optionsList: optionsList })),
                React.createElement(Divider, null),
                React.createElement("div", { className: styles.classifyContentCreateFoot },
                    React.createElement(Button, { type: "primary", onClick: () => createRule() }, getIn18Text('XINJIANFENLEIGUI'))))),
            React.createElement(FolderSelectModal, { parentModalType: modalType, _account: _account, isScopeSent: isScopeSent }))));
};
